// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './root'
import { Route as authRoutesLoginRouteImport } from './auth/routes/login'
import { Route as suppliesRoutesLayoutRouteImport } from './supplies/routes/layout'
import { Route as suppliesRoutesRootRedirectRouteImport } from './supplies/routes/root-redirect'
import { Route as authRoutesSsoIssueRouteImport } from './auth/routes/sso-issue'
import { Route as authRoutesSsoConsumeRouteImport } from './auth/routes/sso-consume'
import { Route as suppliesRoutesIndexRouteImport } from './supplies/routes/index'
import { Route as suppliesRoutesSettingsRouteImport } from './supplies/routes/settings'
import { Route as suppliesRoutesReportsRouteImport } from './supplies/routes/reports'
import { Route as suppliesRoutesReceiveRouteImport } from './supplies/routes/receive'
import { Route as suppliesRoutesMovementsRouteImport } from './supplies/routes/movements'
import { Route as suppliesRoutesItemsRouteImport } from './supplies/routes/items'
import { Route as suppliesRoutesExportRouteImport } from './supplies/routes/export'
import { Route as suppliesRoutesItemDetailRouteImport } from './supplies/routes/item-detail'

const authRoutesLoginRoute = authRoutesLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const suppliesRoutesLayoutRoute = suppliesRoutesLayoutRouteImport.update({
            id: '/_supplies-layout',getParentRoute: () => rootRouteImport
          })
const suppliesRoutesRootRedirectRoute = suppliesRoutesRootRedirectRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const authRoutesSsoIssueRoute = authRoutesSsoIssueRouteImport.update({
            id: '/sso/issue',path: '/sso/issue',getParentRoute: () => rootRouteImport
          })
const authRoutesSsoConsumeRoute = authRoutesSsoConsumeRouteImport.update({
            id: '/sso/consume',path: '/sso/consume',getParentRoute: () => rootRouteImport
          })
const suppliesRoutesIndexRoute = suppliesRoutesIndexRouteImport.update({
            id: '/supplies',path: '/supplies',getParentRoute: () => suppliesRoutesLayoutRoute
          })
const suppliesRoutesSettingsRoute = suppliesRoutesSettingsRouteImport.update({
            id: '/supplies/settings',path: '/supplies/settings',getParentRoute: () => suppliesRoutesLayoutRoute
          })
const suppliesRoutesReportsRoute = suppliesRoutesReportsRouteImport.update({
            id: '/supplies/reports',path: '/supplies/reports',getParentRoute: () => suppliesRoutesLayoutRoute
          })
const suppliesRoutesReceiveRoute = suppliesRoutesReceiveRouteImport.update({
            id: '/supplies/receive',path: '/supplies/receive',getParentRoute: () => suppliesRoutesLayoutRoute
          })
const suppliesRoutesMovementsRoute = suppliesRoutesMovementsRouteImport.update({
            id: '/supplies/movements',path: '/supplies/movements',getParentRoute: () => suppliesRoutesLayoutRoute
          })
const suppliesRoutesItemsRoute = suppliesRoutesItemsRouteImport.update({
            id: '/supplies/items',path: '/supplies/items',getParentRoute: () => suppliesRoutesLayoutRoute
          })
const suppliesRoutesExportRoute = suppliesRoutesExportRouteImport.update({
            id: '/supplies/export',path: '/supplies/export',getParentRoute: () => suppliesRoutesLayoutRoute
          })
const suppliesRoutesItemDetailRoute = suppliesRoutesItemDetailRouteImport.update({
            id: '/supplies/items/$itemId',path: '/supplies/items/$itemId',getParentRoute: () => suppliesRoutesLayoutRoute
          })





const suppliesRoutesLayoutRouteChildren = {
  suppliesRoutesIndexRoute: suppliesRoutesIndexRoute,suppliesRoutesExportRoute: suppliesRoutesExportRoute,suppliesRoutesItemsRoute: suppliesRoutesItemsRoute,suppliesRoutesMovementsRoute: suppliesRoutesMovementsRoute,suppliesRoutesReceiveRoute: suppliesRoutesReceiveRoute,suppliesRoutesReportsRoute: suppliesRoutesReportsRoute,suppliesRoutesSettingsRoute: suppliesRoutesSettingsRoute,suppliesRoutesItemDetailRoute: suppliesRoutesItemDetailRoute
}

const suppliesRoutesLayoutRouteWithChildren = suppliesRoutesLayoutRoute._addFileChildren(suppliesRoutesLayoutRouteChildren)

const rootRouteChildren = {
  suppliesRoutesRootRedirectRoute: suppliesRoutesRootRedirectRoute,suppliesRoutesLayoutRoute: suppliesRoutesLayoutRouteWithChildren,authRoutesLoginRoute: authRoutesLoginRoute,authRoutesSsoConsumeRoute: authRoutesSsoConsumeRoute,authRoutesSsoIssueRoute: authRoutesSsoIssueRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)